import angular from 'angular';

import stateModule from '../../state/state.module';

/* Module Imports */
import datapointDisplayModule from './datapoint-display/datapoint.module';
import roleManagementModule from './role-management/role.module';
import subAccountModule from './sub-accounts/sub-accounts.module';
import securityGroupsModule from './security-groups/securitygroups.module';
import userManagementModule from './user-management/user.module';
import assetsModule from './assets/assets.module';

/* Controller - Route Imports */
import AdminController from './admin.controller';
import AdminRouteConfig from './admin.route';

const adminModule = angular
	.module('app.admin', [
		'ui.bootstrap',
		'ui.router',
		'gettext',
		stateModule,
		datapointDisplayModule,
		roleManagementModule,
		securityGroupsModule,
		userManagementModule,
		assetsModule,
		subAccountModule
	])
	.controller('AdminController', AdminController)
	.config(AdminRouteConfig);

export default adminModule.name;
